$(document).ready(function() {

    function loginCallback(data, status, xhr, form) {
        switch(data.status) {
            case 'CHOOSE':
                return $('#loginModal').attr('data-mode', 'choose').find('#choice_list').html(data.choice.join('<br>')).find('a').click(function(e) {
                    $.ajax(this.href, { success: loginCallback }); return false
                });
            case 'OK':
                var redirectUrl = $('#loginModal').data('redirect-hidden', 'no').modal('hide').data('redirect-url');
                window.location = data.redirectUrl || redirectUrl || window.location;
                return false;
            case 'ERROR':
                if(data.csrf) $(form).find('[name=csrf]').val(data.csrf);
                if(data.flashMessages)
                    return $('#loginModal .alert:first-child').addClass('collapse show').html($('<div>').html(data.flashMessages).find('.alert').html()).find('button').remove();
                else
                    return $('#loginModal .alert:first-child').addClass('collapse show').text(data.message ||'ERROR');
        }
    }

    $('#loginModal').ajaxForm({ success: loginCallback,
        beforeSubmit: function() { $('#loginModal .alert').addClass('collapse').removeClass('show'); $('#loginModal button[type=submit]').prop('disabled',true) },
        complete: function() { $('#loginModal button[type=submit]').prop('disabled',false) },
    });

    $('#register').on('click', function(){
        $('#loginModal').find('input[name=email]').prop('readonly', false).prop('disabled', false);
    });

    $('#loginButton').on('click', function(){
        $('#loginModal .alert').addClass('collapse').removeClass('show');
    });


    $('#loginModal').on('hidden.bs.modal', function () {
        $('#loginModal').attr('data-mode', 'login');
    });

    //EDM: bij het tonen van modal, kijken of het invoker element een data-callback attr heeft, hiernaar mag geforward worden na de login/registratie, dus meegeven in login/registratie form
    $('#loginModal').on('show.bs.modal', function (e) {
        if(e.relatedTarget) $(this).data('redirect-url', $(e.relatedTarget).attr('data-callback')||window.location.href);
        $('#loginform #callback_url, #usernew #new_callback_url').val($(this).data('redirect-url'));
    });

    $('#loginModal').on('hide.bs.modal', function () {
        if($('#loginModal').data('redirect-hidden') == 'yes') {
            var redirectUrl = $('#loginModal').data('redirect-url');
            window.location = redirectUrl || window.location;
        }
    });

    var submitByCode = false;
    $('#usernew, #loginform').submit(async function(e) {
        console.log(e, submitByCode);
        if(submitByCode)
            submitByCode = false;
        else {
            e.preventDefault();
            submitByCode = true;
            if(submitByCode = await validateLoginModal())
                $(this).submit();
        }
    });

    //live email check
    $('#usernew #email').on('change', function(){
        var $email = $(this)
        //indien een geldig regex emailadres: check doen via validateSmtp
        validateEmailAjax($email, function() { $email.parent().addClass('is-valid').removeClass('has-error') }, function() { $email.parent().removeClass('is-valid').addClass('has-error') });
    });

    $('.switch_form').click(function(e){
        e.preventDefault();
        switchForm(true, boolVal($(this).attr('data-validate')), $(this).attr('data-continue'));
    });
});

var validateEmailAjax = (function() {
    var validEmails = {}, blocked = false;
    return async function validateEmailAjax($email, success, error) {
        var email = $email.val();
        if(validateEmail(email)){
            if(blocked)
                await blocked;
            if(validEmails[email] == null) {
                return blocked = new Promise(function(resolve, reject) {
                    spinner($email, true);
                    $.ajax({
                        type: "POST",
                        // dataType: "json",
                        url: "/index/validateemailajax",
                        data: {'email': email},
                        success: function (response) {
                            if (response['isValid'] === true) {
                                validEmails[email] = true;
                                $email.parent().removeClass('has-error').addClass('is-valid');
                                if(success) success();
                                resolve(true)
                            }
                            else {
                                validEmails[email] = false;
                                $fields_ok = false;
                                $message_keys.push('email');
                                $email.parent().removeClass('is-valid').addClass('has-error');
                                if(error) error();
                                resolve(false)
                            }
                        },
                        complete: function() { blocked = false; clearTimeout(tmo); spinner($email, false) }
                    });
                    var tmo = setTimeout(function() { blocked = false; reject('Server not responding'); spinner($email, false) }, 5000);  /* in case ajax goes south */
                });
            }
            else if(validEmails[email]) {
                $email.parent().removeClass('has-error').addClass('is-valid');
                if(success) success();
            }
            else {
                $fields_ok = false;
                $message_keys.push('email');
                $email.parent().removeClass('is-valid').addClass('has-error');
                if(error) error();
            }
        }
        return validEmails[email];

        function spinner($email, active) {
            $email.parent().find('.fa-at').toggleClass('fa-spinner fa-pulse', active)
        }
    }
})()

function rcp(refresh) {
    var site_key = window.grecaptcha && $('#usernew input[name="recaptcha"]').data('site_key');
    if(site_key) {
        if(window.debug) console.log('recaptcha', refresh || false);
        var $input = $('#usernew input[name="recaptcha"]'), promise = $input.data('promise');
        if(!promise ||refresh)
            $input.data('promise', promise = new Promise(function(resolve, reject) {
            grecaptcha.execute(site_key, { action: 'usernew'}).then(function(token) {
                $('#usernew input[name="recaptcha"]').val(token);
                resolve(true);
            }, function() { resolve(false) }, function(e) { console.error(e || 'recaptcha error') });
        }));
        return promise;
    }
}

async function switchForm(keep_alert, validation, mode){
    if(keep_alert === undefined) {
        keep_alert = false;
    }

    TxValidationClear('#loginModal');
    $('#loginModal .alert').addClass('collapse').removeClass('show');

    //alerts hidden
    if(keep_alert) $('#loginModal .alert').removeClass('show');

    if(validation !== false) {
        if(!await validateLoginModal()) return false;
    }
    if(!mode) {
        if($('#loginform').is(':visible'))
            mode = 'usernew'
        else
            mode = 'login'
    }
    $('#loginModal').attr('data-mode', mode);
    $('#loginModal [name=email]').each(function() { $(this).prop('disabled', $(this).attr('data-disabled') || ['usernew2', 'socialnew'].includes(mode)) });
    if(mode == 'usernew')
        rcp()
}

async function validateLoginModal() {
    var $modal = $('#loginModal'), valid;
    TxValidationClear($modal)
    $modal.find('.alert').addClass('collapse').removeClass('show');
    switch($('#loginModal').attr('data-mode')) {
    case 'usernew':
        TxValidateRequiredText($modal.find('[name=email]'));
        TxValidateEmail($modal.find('[name=email]'));
        TxValidateRequiredCheck($modal.find('input[type=checkbox][name=privacy]'));
        var $select = $modal.find('select[name=found]');
        if($select.length) {
            TxValidateRequiredText($select);
            if($select.has('option:checked:last-of-type').length)
                TxValidateRequiredText($modal.find('[name=found_x]'));
        }

        if($fields_ok) {
            var valid = await new Promise(function(resolve, reject) {
                var $form = $modal.find('#usernew');
                $form.ajaxSubmit({data: { prereg: 1},
                    success: function(data, status, xhr, form) {
                        rcp(true);
                        switch(data.status) {
                        case 'OK':
                            return resolve(true);
                        default:
                            if(data.csrf) $(form).find('[name=csrf]').val(data.csrf);
                            if(data.flashMessages)
                                $('#loginModal .alert:first-child').addClass('collapse show').html($('<div>').html(data.flashMessages).find('.alert').html()).find('button').remove();
                            else
                                $('#loginModal .alert:first-child').addClass('collapse show').text(data.message ||'ERROR');
                            return resolve(false);
                        }
                    },
                    error: function() {
                        console.error(arguments);
                        rcp(true);
                        reject('Server not responding');
                    },
                });
            });
            if(!valid) return false;
            var promise = $('#usernew input[name="recaptcha"]').data('promise');
            if(promise)
                if(!await promise)
                    return false;
        }
        break;
    case 'usernew2':
        TxValidateRequiredText($modal.find('input[name=password]'));
        TxPasswordLength($modal.find('input[name=password]'));
        TxMatchPasswords($modal.find('input[name=password]'), $modal.find('input[name=confirm_password]'));
        // the rest should already be ok....
        $('#usernew input[name="recaptcha"]')
        var site_key = window.grecaptcha && $('#usernew input[name="recaptcha"]').data('site_key');
        if(site_key)
            valid = await new Promise(function(resolve, reject) {
                grecaptcha.execute(site_key, { action: 'register'}).then(function(token) {
                    console.log('recaptcha token register', token);
                    $('#usernew input[name="recaptcha"]').val(token);
                    resolve(true);
                }, function() { resolve(false) }, function(e) { console.error(e || 'recaptcha error') });
            });
    case 'privacy':
        TxValidateRequiredCheck($modal.find('input[type=checkbox][name=privacy]'));
        break;
    case 'login':
        TxValidateRequiredText($('#username'));
        TxValidateRequiredText($('#contrasena'));
    }
    console.log('validation', $fields_ok, $message_keys);
    if($fields_ok) return true;
    showErrorMessage($modal, false);
    focusFirstError($modal);
    return false;
}


